import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=4065698e"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"
import style0 from "./Rule.vue?vue&type=style&index=0&id=4065698e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports